"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
function createLogger(namespace) {
    return new skynet_store_utilities_1.Logger('skynet-store-authentication-impl', namespace);
}
exports.createLogger = createLogger;
//# sourceMappingURL=auth.utillities.js.map